import { ProjectType } from "@/types/data";
import XamsCover from '@/assets/images/xams.png'
import NMCover from '@/assets/images/next-manga.png'
import MACover from '@/assets/images/manga-app.png'
import JMCover from '@/assets/images/json-mocking.png'
import IoTFSH from '@/assets/images/IoTFSH.png'
import { AkarIconsTypescriptFill, DeviconPlainBun, MaterialSymbolsFlutter, MdiDocker, MdiTailwind, NextjsIcon, RiFirebaseFill, RiReactjsFill, SimpleIconsDart } from "@/components/icons";

export const projectList: ProjectType[] = [
    {
        name: "XAMS",
        type: "Full-Stack",
        desc: "The Examination and Assignment Management System (XAMS) is designed to streamline the process of creating, managing, and grading examinations and assignments in educational institutions. This system aims to enhance the efficiency of academic operations, reduce administrative burdens, and improve the overall experience for students and educators.",
        cover: XamsCover,
        technologies: [
            <NextjsIcon width={22} height={22}/>,
            <DeviconPlainBun width={22} height={22}/>,
            <MdiTailwind width={22} height={22}/>,
            <AkarIconsTypescriptFill width={22} height={22}/>,
            <MdiDocker width={22} height={22}/>
        ],
        href: "https://github.com/1CEs/xams"
    },
    {
        name: "Next Manga",
        type: "Full-Stack",
        desc: "this project was born cause the pain point is everytime i read some manga or manhwa i'll get a advertisement banner that annoying me so much and yeah this is manga site that has no advertisement anymore !!!!!",
        cover: NMCover,
        technologies: [
            <NextjsIcon width={22} height={22}/>,
            <DeviconPlainBun width={22} height={22}/>,
            <MdiTailwind width={22} height={22}/>,
            <AkarIconsTypescriptFill width={22} height={22}/>,
        ],
        href: "https://github.com/ISongwuts/next-manga"
    },
    {
        name: "Manga App",
        type: "Full-Stack",
        desc: "A modern React Native application built with Expo for manga enthusiasts. This app provides a seamless reading experience with a beautiful UI and smooth navigation.",
        cover: MACover,
        technologies: [
            <RiReactjsFill width={22} height={22}/>,
            <DeviconPlainBun width={22} height={22}/>,
            <MdiTailwind width={22} height={22}/>,
            <AkarIconsTypescriptFill width={22} height={22}/>,
        ],
        href: "https://github.com/1CEs/manga-app"
    },
    {
        name: "JSON Mocking",
        type: "Frontend",
        desc: "I created this project to demonstrate how to set up a modern web development environment using React, TypeScript, and Vite. The goal is to provide a hands-on example of how to create a mock JSON website, which can be particularly useful for front-end developers who need to simulate data fetching and handling in their applications.",
        cover: JMCover,
        technologies: [
            <NextjsIcon width={22} height={22}/>,
            <DeviconPlainBun width={22} height={22}/>,
            <MdiTailwind width={22} height={22}/>,
            <AkarIconsTypescriptFill width={22} height={22}/>,
            <MdiDocker width={22} height={22}/>
        ],
        href: "https://github.com/ISongwuts/react-json-mocking"
    },
    {
        name: "IoTFSH App",
        type: "Full-Stack",
        desc: "This graduate project aims to develop a Smart Home Automation System using Flutter for the mobile application interface and Firebase for cloud-based backend services. The system allows users to monitor and control home devices in real-time from their smartphones, improving convenience, safety, and energy efficiency.",
        cover: IoTFSH,
        technologies: [
            <MaterialSymbolsFlutter width={22} height={22}/>,
            <SimpleIconsDart width={22} height={22}/>,
            <RiFirebaseFill width={22} height={22}/>
        ],
        href: "https://github.com/ISongwuts/IOT-APP"
    }
]